import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

const Privacy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pt-24 pb-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400 hover:text-blue-500 transition-colors mb-8 dark:hover:text-indigo-200"
        >
          <ArrowLeft className="w-4 h-4" />
          {t("common.returnHome")}
        </Link>

        <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm px-8 py-10 space-y-8">
          <div className="border-b border-gray-100 dark:border-gray-800 pb-6">
            <h1 className="text-2xl font-black text-gray-900 dark:text-gray-50">
              {t("legal.privacyTitle")}
            </h1>
            <p className="text-sm text-gray-400 dark:text-gray-500 mt-1">
              {t("legal.lastUpdated")}: 01.09.2026
            </p>
          </div>

          {[1,2,3,4,5,6,7,8,9,10].map((n) => (
            <Section key={n} title={t(`legal.privacy.section${n}Title`)}>
              {t(`legal.privacy.section${n}Body`)}
            </Section>
          ))}

          <div className="pt-4 border-t border-gray-100 dark:border-gray-800 text-sm text-gray-500 dark:text-gray-400">
            {t("legal.contactUs")}{" "}
            <Link to="/contact" className="text-blue-500 hover:text-blue-700 font-medium transition-colors dark:text-indigo-300 dark:hover:text-indigo-200">
              {t("legal.contactLink")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="text-base font-bold text-gray-800 dark:text-gray-100">{title}</h2>
    <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">{children}</p>
  </div>
);

export default Privacy;
